import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/PageSection.scss';

export default function PageSection({
    children,
    className,
    depth = 1,
    ...props
}) {
    const classes = classNames(
        styles.section,
        styles[`depth-${depth}`],
        className
    );

    return (
        <div {...props} className={classes}>
            <div className={styles.inner}>
                {children}
            </div>
        </div>
    );
}

PageSection.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    depth: PropTypes.number,
};
